import { useCallback } from "react";
import { Checkbox } from "@chakra-ui/react";
import { useDonateToGitcoin } from "../DonateToGitcoinContext";
import React from "react";
import { DonateToGitcoinContent } from "./components/DonateToGitcoinContent";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DonateToGitcoin = /*#__PURE__*/React.memo(_ref => {
  let {
    totalAmount,
    totalDonationsByChain
  } = _ref;
  const {
    isEnabled,
    setIsEnabled
  } = useDonateToGitcoin();
  const handleCheckboxChange = useCallback(value => {
    setIsEnabled(value.target.checked);
  }, [setIsEnabled]);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-start gap-[9px] p-[9px] border-[0.75px] border-[#E3E3E3] rounded-[7.5px] bg-[#F5F4FE]",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("p", {
        className: "flex items-center",
        children: [/*#__PURE__*/_jsx(Checkbox, {
          className: `mr-2 ${!isEnabled ? "opacity-50" : ""}`,
          border: "1px",
          borderRadius: "4px",
          colorScheme: "whiteAlpha",
          iconColor: "black",
          size: "lg",
          isChecked: isEnabled,
          onChange: handleCheckboxChange
        }), /*#__PURE__*/_jsx("img", {
          className: "inline mr-2 w-5 h-5",
          alt: "Gitcoin",
          src: "/logos/gitcoin-gist-logo.svg"
        }), /*#__PURE__*/_jsx("span", {
          className: "text-[15px] font-medium font-inter text-black",
          children: "Donate to Gitcoin"
        })]
      })
    }), /*#__PURE__*/_jsx(DonateToGitcoinContent, {
      totalAmount: totalAmount,
      totalDonationsByChain: totalDonationsByChain
    })]
  });
}, (prevProps, nextProps) => prevProps.totalAmount === nextProps.totalAmount);